module.exports = __webpack_public_path__ + "img/dink-bedroom-5.cd3293ee.jpeg";